import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.active)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["modal", {'active': $setup.visible}])
      }, [
        _createElementVNode("div", null, [
          (!$setup.modal.props['required'])
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "close",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args)))
              }, _cache[1] || (_cache[1] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 16 16"
                }, [
                  _createElementVNode("path", { d: "M9.42,7.96L15.24,2.14c.35-.35,.35-.92,0-1.27s-.92-.35-1.27,0l-5.82,5.82L2.33,.87c-.35-.35-.92-.35-1.27,0s-.35,.92,0,1.27L6.88,7.96,1.06,13.79c-.35,.35-.35,.92,0,1.27,.18,.18,.4,.26,.63,.26s.46-.09,.63-.26l5.82-5.82,5.82,5.82c.18,.18,.4,.26,.63,.26s.46-.09,.63-.26c.35-.35,.35-.92,0-1.27l-5.82-5.82Z" })
                ], -1)
              ])))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.component())))
        ])
      ], 2))
    : _createCommentVNode("", true)
}